// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
table td > span[data-v-6c2dd066], table th > span[data-v-6c2dd066] {
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
}
.resultsTable thead th[data-v-6c2dd066], .resultsTable tbody th[data-v-6c2dd066] {
  vertical-align: top;
}
table td > span span[data-v-6c2dd066], table th > span span[data-v-6c2dd066] {
  padding-right: 5px;
}
`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
